import { isBridgeCaseOpen } from '@web-app/components/MedicareBridge/case-visibility';
import { MedicareBridgeBadge } from '@web-app/components/MedicareBridge/MedicareBridgeBadge';
import { useMedicareBridgeCase } from '@web-app/hooks/medicare-bridge/useMedicareBridgeCase';

export function MedicareBridgeStatus({
  patientHealthieId,
  onDark = false,
}: {
  patientHealthieId: string;
  onDark?: boolean;
}) {
  const query = useMedicareBridgeCase(patientHealthieId);
  // Header and profile load this for every patient. A gateway failure stays
  // quiet here; the visit Bridge panel is the place that offers a retry.
  if (!query.data || !isBridgeCaseOpen(query.data)) return null;
  return <MedicareBridgeBadge bridgeCase={query.data} onDark={onDark} />;
}
